import { Roles } from '@/core/constants/roleConstants';
import { hasAnyRole } from './helpers';
import store from '@/store';

export const backordersGuard = () => {
  const roles = store.getters['auth/roles'];

  if (hasAnyRole(roles, ['Guest'])) {
    return { name: '403' };
  }

  // REDIRECT TO BACKORDER VIEW BASED ON ROLE
  if (hasAnyRole(roles, [Roles.REGIONAL_MANAGER])) {
    return { name: 'backordersHistoryRegional' };
  }

  if (hasAnyRole(roles, [Roles.MANAGER])) {
    return { name: 'backordersHistoryManager' };
  }

  if (hasAnyRole(roles, [Roles.SELLER])) {
    return { name: 'backordersHistorySeller' };
  }

  if (hasAnyRole(roles, [Roles.EXPRESS_SALES])) {
    return { name: 'backordersHistory' };
  }

  return { name: 'backordersCustomer' };
};
